import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '~/modules/query/base';
import { AI_API_URL } from '~/lib/environment';

/**
 * The AI Manager service's own tag registry. It shares the Toolbox axios transport
 * (cookie token, 401 redirect) but not the sysbay `{result}` unwrapping rule:
 * service-ai returns `{success, data}`, `{configs}`, `{placements}`, raw CSV, etc.
 */
export const AI_TAG_TYPES = [
  'AiSettings',
  'AiUsage',
  'AiUsageStats',
  'AiTokenLimits',
  'AiAnalytics',
  'AiPlacement',
  'AiPlacementHistory',
  'AiPersona',
  'AiAssistant',
  'AiAssistantVersions',
  'AiProviders',
  'AiFieldCatalog',
  'AiAgents',
  'AiProviderModels',
] as const;

export type AiTagType = (typeof AI_TAG_TYPES)[number];

export const aiApi = createApi({
  reducerPath: 'aiApi',
  baseQuery: axiosBaseQuery({ baseUrl: AI_API_URL }),
  tagTypes: [...AI_TAG_TYPES],
  endpoints: () => ({}),
});
